import { createContext, useContext, type RefObject } from 'react';

import type { PiiResult } from '@/lib/pii/server-pii';

export type PiiVerdict<Result extends PiiResult = PiiResult> = {
  result: Result;
  /** The guest's message the server judged; only that message is edited. */
  messageId: string | undefined;
};

export type PiiResultListener = (verdict: PiiVerdict) => void;

export type PiiResultChannel = RefObject<PiiResultListener | null>;

export const PiiResultChannelContext = createContext<PiiResultChannel | null>(null);

export function usePiiResultChannel(): PiiResultChannel | null {
  return useContext(PiiResultChannelContext);
}
